import { styled } from '@mui/system';
import { TextField, Typography } from '@mui/material';
import React from 'react';
import textData from '../data/data.json';
import { languagesAtom, selectedLanguageAtom } from '../recoil/atoms/languageAtom';
import { useRecoilState, useRecoilValue } from 'recoil';
import Dropdown from './dropdowns/dropdown';
import { ReactComponent as Globe } from '../images/globe.svg';

const Wrapper = styled('div')({
    flex: '0 0 100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '50px',
    alignItems: 'center',
    minHeight: '300px',
    width: '100%',
    maxWidth: '100%',
});

const Title = styled(Typography)({
    fontSize: '30px',
});

const FieldsWrapper = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    alignItems: 'center',
    width: '100%',
    maxWidth: '100%',
});

const Label = styled(Typography)({
    fontSize: 24,
    lineHeight: '120%',
});

const Input = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    width: '100%', 
    gap: 10,
});

const QuizPersonalData = ({ name, surname, isLeader, onChangeName, onChangeSurname }) => {
    const [selectedLanguage, setSelectedLanguage] = useRecoilState(selectedLanguageAtom);
    const languages = useRecoilValue(languagesAtom);
    const selectedLanguageIndex = languages.findIndex(({ code }) => selectedLanguage === code);
    const { quizPersonalData } = textData[selectedLanguage];

    const handleLanguageChange = ({ code }) => {
        setSelectedLanguage(code);
        localStorage.setItem('language', code);
    };

    return (
        <Wrapper>
            <Title variant={'h1'}>{quizPersonalData.title}</Title>
            <FieldsWrapper>
                <Input>
                    <Label variant={'h1'}>{quizPersonalData.fields.name.label}</Label>
                    <TextField
                        value={name}
                        onChange={onChangeName}
                        placeholder={quizPersonalData.fields.name.placeholder}
                    />
                </Input>
                <Input>
                    <Label variant={'h1'}>{quizPersonalData.fields.surname.label}</Label>
                    <TextField
                        value={surname}
                        onChange={onChangeSurname}
                        placeholder={quizPersonalData.fields.surname.placeholder}
                    />
                </Input>
                {languages && !isLeader && (
                    <Input>
                        <Label variant={'h1'}>{quizPersonalData.fields.language.label}</Label>
                        <Dropdown
                            startIcon={Globe}
                            variant="dropdownBlueMiddle"
                            options={languages.map(({ title, code }) => ({ code, name: title }))}
                            setSelectedOption={handleLanguageChange}
                            selected={selectedLanguageIndex}
                        />
                    </Input>
                )}
            </FieldsWrapper>
        </Wrapper>
    );
};

export default QuizPersonalData;
